import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Eye } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export const ImpersonationBanner = () => {
  const { user, stopImpersonation } = useAuth();
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  if (!user?.impersonation) return null;

  const leave = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (await stopImpersonation()) navigate("/admin", { replace: true });
    } catch {
      toast.error("Impossibile terminare la sessione di supporto. Riprova.");
    } finally { setBusy(false); }
  };

  const expires = new Date(user.impersonation.expires_at).toLocaleTimeString("it-IT", {
    hour: "2-digit", minute: "2-digit",
  });
  return <div role="status" className="shrink-0 border-b-2 border-black bg-[#F0F0F0] px-5 pb-4 pt-16 md:px-8 md:py-3"
    data-testid="impersonation-banner">
    <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3">
      <div className="flex min-w-0 items-start gap-3">
        <Eye className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
        <div className="min-w-0 text-sm leading-relaxed">
          <strong className="block break-words" data-testid="impersonation-tenant-name">
            Supporto · {user.tenant_name}
          </strong>
          <span data-testid="impersonation-readonly-notice">
            Sola lettura: nessuna modifica consentita · Sessione fino alle {expires}
            {user.access_state !== "active" && ` · Abbonamento ${user.access_state === "expired" ? "scaduto" : "sospeso"}`}
          </span>
        </div>
      </div>
      <button type="button" onClick={leave} disabled={busy}
        className="inline-flex shrink-0 items-center gap-2 border border-black px-3 py-2 text-xs font-semibold text-black transition-colors hover:bg-black hover:text-white disabled:opacity-50"
        data-testid="impersonation-return-button">
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />{busy ? "Uscita..." : "Torna al SuperAdmin"}
      </button>
    </div>
  </div>;
};